<template>
	<div class="addedservice">
		<el-checkbox v-model="checkedall" v-if="!vertical" @change="checkall">全选</el-checkbox>
		<el-divider v-if="!vertical"></el-divider>
		<table class="servicehead" v-if="vertical">
			<thead>
				<td >服务名称</td>
				<td style="width:100px;text-align:center;">是否已处理</td>
			</thead>
		</table>
		<div class="servicetable">
			<table v-if="vertical">
				<tr v-for="(item,index) in servicelist" :key="index">
					<td>
						<el-checkbox v-model="item.ischecked" :disabled="item.disabled">{{item.d_name}}</el-checkbox>
						<el-input size="mini" v-if="item.d_value=='price'&&item.ischecked" v-model="item.factprice"></el-input>
					</td>
					<td style="width:100px;text-align:center;">
						<el-switch
						  v-model="item.handled" 
						  @change="changehandle(item)"
						  active-color="#13ce66">
						</el-switch>
					</td>
				</tr>
			</table>
		</div>
		<div v-if="!vertical" class="servicelist">
			<label v-for="(item,index) in servicelist" :key="index">
				<el-checkbox v-model="item.ischecked">{{item.d_name}} </el-checkbox>
				<el-input size="mini" v-if="item.d_value=='price'&&item.ischecked" v-model="item.factprice" :placeholder="'请输入'+item.d_name+'金额'"></el-input>
			</label>
		</div>
	</div>
</template>
<script>
import Utils from '../../lib/util.js';
export default {
	components: {
		
	},
	props: {
		
	},
	data() {
		return {
			servicelist:[{id:'',d_name:'合箱',ischecked:true,disabled:true},{id:'',d_name:'拆箱',ischecked:true,disabled:true},{id:'',d_name:'保价',ischecked:true,disabled:true},{id:'',d_name:'复重',ischecked:true,disabled:true},{id:'',d_name:'取发票',ischecked:true,disabled:true},{id:'',d_name:'仓储',ischecked:true,disabled:true},{id:'',d_name:'信息不全拦截',ischecked:true,disabled:true}],
			p_pkval:'',//订单号，可能是多个 也可能是单个
			loadall:true,//是否加载所有服务选项
			changeresult:false,//是否可以更改操作结果
			vertical:false ,//是否纵向显示
			divclass:'addedservice',
			checkedall:false
		}
	},
	mounted() {
		this.$apipost.get.getTheme().then(res => {
			import('../../static/' + res + '/style/baseinfo/addedservice.scss');
		});
	},
	methods: {
		init(param){
			this.servicelist=[];
			if(param!=undefined)
			{
				if(param.p_pkval!=undefined)
					this.p_pkval=param.p_pkval;
				if(param.loadall!=undefined)
					this.loadall=param.loadall;	
					
				if(param.changeresult!=undefined)
					this.changeresult=param.changeresult;	
				if(param.vertical!=undefined)
					this.vertical=param.vertical;	
				if(param.servicelist!=undefined){
					if(param.servicelist!="")
						param.servicelist=JSON.parse(param.servicelist);
					this.loadallservice(param.servicelist);
				}
					
			}
		},
		//加载增值服务选项
		loadallservice(servicelist){
			var that=this;
			this.$tool.loading('正在加载', this.divclass);
			this.$apipost.get.dic({ type: '增值服务' }).then(res => {
				this.$tool.loadingclose();
				if (res != '') {
					var list=res.list;
					//将匹配的服务设置为选中
					list.forEach(e=>{
						e.ischecked=false;
						e.handled=false;
						if(servicelist!=''){
							servicelist.forEach(b=>{
								if(b.id==e.id){
									e.ischecked=true;
									e.handled=b.handled;
									if(e.d_value=='price'){
										e.price=b.price;
										e.factprice=b.factprice;
									}
								}
							});
						}
					});
					if(that.loadall)
						that.servicelist=list;
					else
					{
						//只显示选中的 
						var newlist=list.filter(function(e){
							return e.ischecked==true;
						});
						newlist.forEach(e=>{
							e.disabled=true;
						})
						that.servicelist=newlist;
					}
				}
			});
		},
		checkall(){
			var that=this;
			this.servicelist.forEach(e=>{
				e.ischecked=that.checkedall;
			});
		},
		changehandle(item){
			this.$emit('servicehandle', item);
		}
	}
}
</script>

